import { defineComponent as _defineComponent } from 'vue'
import {ref} from 'vue';
import {useRouter} from 'vue-router';
import {getRelatedProcessList} from '@/api/miscellaneous';
import moment from 'moment';


export default /*#__PURE__*/_defineComponent({
  __name: 'RelatedProcessing',
  props: {
    active: {
        type: String,
        default: '',
    },
},
  setup(__props, { expose }) {
  expose();

const props = __props


const router = useRouter();

const list = ref<any[]>([]);
const getListData = ref({
    page: 1,
    size: 10,
});
const loading = ref(false);
const finished = ref(false);

const getList = () => {
    // if (loading.value) return;
    // loading.value = true;
    getRelatedProcessList(getListData.value).then((res: any) => {
        list.value = [...list.value, ...res.items];
        getListData.value.page += 1;
        loading.value = false;
        finished.value = getListData.value.page * getListData.value.size >= res.total;
    });
};
getList();

const __returned__ = { props, router, list, getListData, loading, finished, getList, ref, useRouter, getRelatedProcessList, moment }
Object.defineProperty(__returned__, '__isScriptSetup', { enumerable: false, value: true })
return __returned__
}

})